import axios from "axios";
import { url } from "./index";

export const ApiCall = async ({ params, route, verb, token, baseurl }) => {
  try {
    let url2 = null;
    if (baseurl === false) {
      url2 = route;
    } else {
      url2 = `${url}/${route}`;
    }
    // console.log("url", url);
    console.log("params", params);

    let response = null;
    switch (verb) {
      case "get":
        response = await axios.get(
          url2,
          token ? { headers: { Authorization: `Bearer ${token}` } } : null
        );
        break;
      case "post":
        response = await axios.post(
          url2,
          params,

          token ? { headers: { Authorization: `Bearer ${token}` } } : null
        );
        break;
      case "put":
        response = await axios.put(
          url2,
          params,
          token ? { headers: { Authorization: `Bearer ${token}` } } : null
        );
        break;
      case "patch":
        response = await axios.patch(
          url2,
          params,
          token ? { headers: { Authorization: `Bearer ${token}` } } : null
        );
        break;
      case "delete":
        response = await axios.delete(
          url2,
          token ? { headers: { Authorization: `Bearer ${token}` } } : null,
          params
        );
        break;

      default:
        return { code: "400", response: "methord not found" };
      // break;
    }

    if (response) {
      return await { status: 200, response: response.data };
    } else {
      return response;
    }
  } catch (e) {
    // handle error
    return { status: 400, response: e.response.data };
  }
};
